export default "__VITE_ASSET__DD_GNARG__"